import { useEffect } from "react";
import Tasks from "./../components/Tasks";
import Appointments from "./../components/Appointments";
import PatientDetails from "../components/PatientDetails";
import OverviewFooter from "../../../pages/Dashboard/OverviewTab/components/OverviewFooter";
import NominatedPharmacy from "../components/NominatedPharmacy";
import Contact from "../components/Contact";
import Actions from "../components/Actions";
import LifetimeValue from "../components/LifetimeValue";
import Summary from "../components/Summary/Summary";
import AppleHealth from "../components/AppleHealth/AppleHealth";
import { setCurrentShowPatientPrescriptionModal } from "../../../dispatchers/patientDispatchers";
import useTitanApp from "../../../hooks/useTitanApp";
import DashboardPrescriptions from "../components/History/components/DashboardPrescriptions";
import History from "../components/History/History";
import ReferralLetterModal from "../components/History/components/ReferralLetterModal";
import PatientDashboardVitals from "../components/PatientDashboardVitals";
import PrescriptionModal from "../../../pages/PrivateService/PrescriptionModal";
import Consultation from "../../../pages/Consultation/Consultation";
import Consultations from "../Consultations";
import ActiveConsultations from "../ActiveConsultations";

export default function PatientDashboardPage({
  onDarkModeChange,
  onSectionChange,
}) {
  const { patientState } = useTitanApp();
  const { showPatientPrescriptionModal } = patientState;
  useEffect(() => {
    const sectionIds = [
      "patient-dboard-wrapper",
      "patient-details-wrapper",
      "patient-appointments-wrapper",
      "lifetimeValue-wrapper",
      "summary-details-wrapper",
      "appleHealth-wrapper",
    ];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (onSectionChange) onSectionChange(entry.target.id); // tell parent
          }
        });
      },
      {
        rootMargin: "0px 0px -60% 0px", // detects entry slightly before fully visible
        threshold: 0.3,
      },
    );

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect(); // cleanup
  }, []);

  const handleClosePrescriptionModal = () => {
    setCurrentShowPatientPrescriptionModal(false);
  };
  const patientDetails = [
    {
      label: "Date of Birth",
      value: "18/10/1968 (51)",
    },
    {
      label: "Sex",
      value: "Female",
    },
    {
      label: "NHSNo",
      value: "630 783 7632",
    },
    {
      label: "Address",
      value: "154 Albany St, London, NW1 4DH, UK",
    },
    {
      label: "Ethnicity",
      value: "White - Irish",
    },
    {
      label: "Surgery",
      value: "Name of surgery",
    },
    {
      label: "Allergies",
      value: ["Hayfever", "Pennicilin", "Aspirin"],
    },
  ];

  const contactDetails = [
    {
      label: "Email",
      value: "jess.aubree@gmail .com",
    },
    {
      label: "Phone Number",
      value: "+44 (0) 7776 495586",
    },
  ];

  const dataSetOne = [
    {
      name: "JAN",
      uv: 590,
      pv: 800,
      amt: 1400,
      cnt: 490,
    },
    {
      name: "FEB",
      uv: 868,
      pv: 967,
      amt: 1506,
      cnt: 590,
    },
    {
      name: "MAR",
      uv: 1397,
      pv: 1098,
      amt: 989,
      cnt: 350,
    },
    {
      name: "APR",
      uv: 868,
      pv: 967,
      amt: 1506,
      cnt: 590,
    },
    {
      name: "MAY",
      uv: 590,
      pv: 800,
      amt: 1400,
      cnt: 490,
    },
    {
      name: "JUN",
      uv: 1520,
      pv: 1108,
      amt: 1100,
      cnt: 460,
    },
    {
      name: "JULY",
      uv: 590,
      pv: 800,
      amt: 1400,
      cnt: 490,
    },
    {
      name: "AUG",
      uv: 1397,
      pv: 1098,
      amt: 989,
      cnt: 350,
    },
    {
      name: "SEP",
      uv: 1520,
      pv: 1108,
      amt: 1100,
      cnt: 460,
    },
    {
      name: "OCT",
      uv: 868,
      pv: 967,
      amt: 1506,
      cnt: 590,
    },
    {
      name: "NOV",
      uv: 590,
      pv: 800,
      amt: 1400,
      cnt: 490,
    },
    {
      name: "DEC",
      uv: 1520,
      pv: 1108,
      amt: 1100,
      cnt: 460,
    },
  ];

  return (
    <>
      <div className="overview_tab" id="patient-overview-wrapper">
        <div className="overview_col-1" id="patient-tasks-wrapper">
          {/* <Tasks onDarkModeChange={onDarkModeChange} /> */}
        </div>
        <div className="overview_col-2 patient-dashboard-col-2">
          <PatientDetails onDarkModeChange={onDarkModeChange} />
          <ActiveConsultations />
          <Appointments />
          {/* <LifetimeValue dataSetOne={dataSetOne} /> */}
          <History />
          <PatientDashboardVitals />
          {/* <Summary /> */}
        </div>
        <div className="overview_col-3">
          {/* <NominatedPharmacy /> */}
          <Contact />
          <Actions />
        </div>

        {/* <OverviewFooter onDarkModeChange={onDarkModeChange} /> */}
      </div>
      <div className="pc-sections quick-actions">
        <div className="pc-content">
          <div className="pc-content-wrapper">
            <ReferralLetterModal />
          </div>
        </div>
        <PrescriptionModal
          show={showPatientPrescriptionModal}
          handleClose={handleClosePrescriptionModal}
        />
      </div>
    </>
  );
}
